import { z } from "zod";
import { dmaCalculationResultParameterDtoSchema } from "./dma-calculation-result-parameter.schema";
export const dmaCalculationResultDtoSchema = z.object({
    parameters: z.array(dmaCalculationResultParameterDtoSchema),
});
